import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PageProps, PERMISSION, SECURABLE} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import mdEntityService from "core/metamodel/mdEntityService";
import {PARTYCATEGORY, PARTYROLE} from "party/partyDomain";
import {loc} from "core/common/config/locales";

const gridLocation = 'partyDrivers';

@observer
export default class DriverList extends  PageAncestor<PageProps, undefined> {

  static module = MODULE.party;
  static title = loc.i18n`Drivers`;
  static icon = 'truck';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("DriverList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
      });
  }




  render() {
    let {params, query} = this.props;


    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}
                           multiUpdateSecurable={SECURABLE.partyGridUpdate} >
          <ZzFlatButtonRoute onGridToolbar routeName="partyDetail" params={{id: 'new'}} query={{partyCategory: PARTYCATEGORY.PE, roles:PARTYROLE.DRIVER}} label="New Driver" permission={PERMISSION.New}/>
        </GridCompConnected>
    );
  }

}



// WEBPACK FOOTER //
// ./src/party/page/driverList.tsx